/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { CurativeActionService } from './CurativeActionService';

class CurativeActionServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new CurativeActionService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { CurativeActionServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/service/CurativeActionServiceProvider.js